<template>
    <nav id="sidebar">
        <div class="sidebar-header">
            <div @click="toggleToIcons()" style="margin-top: 65px; margin-left: 5px;">
                <span class="menu-item-name app-heading"></span>
            </div>
        </div>
        <ul class="list-unstyled" v-if="isManageType">
            <li class="active" >
                <router-link to="/enterprise-admin-dashboard" :class="[currentPage.includes('enterprise-admin-dashboard') ? activeClass : '']">
                <img src="@/assets/enterprise/Dashboard_16x16.png" />
                <span class="menu-name">Dashboard</span>
                </router-link>
            </li>
            <li>
                <router-link to="/locations" :class="[currentPage.includes('locations') ? activeClass : '']">
                <img src="@/assets/enterprise/Location_16x16.png" />
                <span class="menu-name">Locations</span>
                </router-link>
            </li>

            <li>
                <router-link to="/enterprise-admin/purchasing" :class="[currentPage.includes('purchasing') ? activeClass : '']">
                <img src="@/assets/enterprise/Purchasing_16x16.png" />
                <span class="menu-name">Purchasing</span>
                </router-link>
            </li>
            <li>
              <a href="#">
                <img src="@/assets/enterprise/Reporting_16x16.png" />
                <span class="menu-name">Reports</span>
              </a>
            </li>

            <li>
               <router-link to="/resourses" :class="[currentPage.includes('resourses') ? activeClass : '']">
                <img src="@/assets/enterprise/Resources_16x16.png" />
                <span class="menu-name">Resources</span>
               </router-link>
            </li>
            <li>
              <router-link to="/enterprise" :class="[currentPage.includes('/enterprise/') ? activeClass : '']">
                <img src="@/assets/enterprise/Enterprise_16x16.png" />
                <span class="menu-name">Enterprise</span>
              </router-link>
            </li>
        </ul>

        <ul class="list-unstyled" v-if="!isManageType">
            <li class="active" >
                <router-link to="/enterprise-admin-dashboard" :class="[currentPage.includes('enterprise-admin-dashboard') ? activeClass : '']">
                <img src="@/assets/enterprise/Dashboard_16x16.png" />
                <span class="menu-name">Dashboard</span>
                </router-link>
            </li>
            <li>
                <router-link to="/locations" :class="[currentPage.includes('locations') ? activeClass : '']">
                <img src="@/assets/enterprise/Location_16x16.png" />
                <span class="menu-name">Locations</span>
                </router-link>
            </li>
            <li>
              <a href="#">
                <img src="@/assets/enterprise/Reporting_16x16.png" />
                <span class="menu-name">Reports</span>
              </a>
            </li>
            <li>
              <router-link to="/enterprise" :class="[currentPage.includes('/enterprise/') ? activeClass : '']">
                <img src="@/assets/enterprise/Enterprise_16x16.png" />
                <span class="menu-name">Enterprise</span>
              </router-link>
            </li>
        </ul>
        
        <div class="heading-seperator"></div>
        
        <ul class="list-unstyled" v-if="isManageType">
            <li class="active">
                <b-link v-b-toggle="'collapse-buildable-submenu'" :class="user_menu_visible ? null : 'collapsed'">
                    <span class="menu-name font-weight-bold">Users
                      <i v-if="!user_menu_visible" class="fa fa-angle-down report-dropdown" style="font-size: 26px;"></i>
                      <i v-if="user_menu_visible" class="fa fa-angle-up report-dropdown" style="font-size: 26px;"></i>
                    </span>
                </b-link>
            </li>
            <b-collapse v-bind:id="'collapse-buildable-submenu'" v-model="user_menu_visible">
            <ul class="nav flex-column user_nav_bar">
                <li>
                  <router-link to="/users/managers" :class="[currentPage.includes('/users/managers/') ? activeClass : '']">
                    <span class="menu-name">Managers</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/users/mentors" :class="[currentPage.includes('/users/mentors/') ? activeClass : '']">
                    <span class="menu-name">Mentors</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/users/mentees" :class="[currentPage.includes('/users/mentees/') ? activeClass : '']">
                    <span class="menu-name">Mentees</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/users/apprentices" :class="[currentPage.includes('/users/apprentices/') ? activeClass : '']">
                    <span class="menu-name">Apprentices</span>
                  </router-link>
                </li>
            </ul>
            </b-collapse>
        </ul>
    </nav>
</template>

<script>
export default {
  props: ['readOnly'],
  data() {
    return {
      activeClass: 'nav-active',
      sidemenu_minimized: '',
      user_menu_visible: false,
    }
  },
  computed: {
    currentPage() {
      return this.$route.path;
    },
    isManageType() {
      if (this.$store.state.enterprise_type === 'Readonly') {
        return false;
      } else {
        if (this.$store.state.switch_admin_enterprise_isreadonly) {
          return false;
        } else {
          return true;
        }
      }
    }
  },
  methods: {
   toggleToIcons() {
     document.getElementById('sidebar').classList.toggle("active");
     let minimized = '';
     if(document.getElementById('sidebar').classList == 'active')
     {
        minimized = 'active';
     }
     this.$store.dispatch('sidebar_menu_minimized', minimized);
   }
  },
  created() {
    this.sidemenu_minimized = this.$store.state.sidebar_menu_minimized;
    document.body.className = 'ma-body-bgcolor';

    if (this.$route.path == '/users/managers' 
      || this.$route.path == '/users/mentors'
      || this.$route.path == '/users/mentees'
      || this.$route.path == '/users/apprentices') {
      this.user_menu_visible = true;
    }
  }

}
</script>

<style>
.heading-seperator {
  /* border-bottom: 2px solid #dc2227; */
  border-bottom: 2px solid #00ACEE;
  margin: 10px 10px 0px 10px;
}
.heading {
  font-size: 15px;
  padding-left: 20px;
}
#sidebar {
    min-width: 250px;
    max-width: 250px;
    background-color: #D4D4D4;
    min-height: 100vh;
    transition: opacity 2s linear;
    transform:translate(0);
    opacity: 1;
}
#sidebar.active {
    min-width: 60px;
    max-width: 60px;
    text-align: center;
}
#sidebar.active .menu-item-name {
   display: none;
}
#sidebar.active .sidebar-header h3 {
    display: none;
}

#sidebar.active .sidebar-header strong {
    display: block;
}

#sidebar ul li a {
    text-align: left;
    text-decoration: none;
}

#sidebar.active ul li a {
    padding: 0px 10px;
    text-align: center;
    font-size: 0.85em;
    text-decoration: none;
}

#sidebar.active ul li a i {
    margin-right: 0;
    display: block;
    font-size: 16px;
}

#sidebar.active ul ul a {
    padding: 10px !important;
}

#sidebar.active .dropdown-toggle::after {
    top: auto;
    bottom: 10px;
    right: 50%;
    -webkit-transform: translateX(50%);
    -ms-transform: translateX(50%);
    transform: translateX(50%);
}

#sidebar .sidebar-header {
    padding: 0px 10px 10px 10px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
}

#sidebar ul.components {
    padding: 5px 0;
    border-bottom: 1px solid #47748b;
}
#sidebar ul li a {
    padding: 0px 10px 0px 10px;
    display: block;
    color: #212529;
    margin-left: 5px;
}
#sidebar ul ul li a {
    padding: 2px;
}
#sidebar ul li a i {
    margin-right: 10px;
}
#sidebar ul li.active>a,
#sidebar a[aria-expanded="true"] {
    color: #212529;
}
a[data-toggle="collapse"] {
    position: relative;
}
.dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
}
.app-heading {
 margin-left: 10px;
}
.list-signout-menu {
  bottom: 0px;
  position: absolute;
}
.report-dropdown {
  float: right;
  font-weight: 900;
}
#sidebar.active ul ul {
  display: none;
}
#sidebar ul li {
  padding-top: 10px;
  padding-bottom: 10px;
}
#sidebar ul li a.nav-active, #sidebar ul li a.router-link-exact-active {
  /* border-left: 3px solid red; */
  border-left: 3px solid #00ACEE;
  margin-left: 2px;
}
#sidebar ul li a i {
  width: 15px;
}
#sidebar.active ul li a i {
  width: 35px;
}
#collapse-report-submenu ul li {
  padding-top: 0px;
  padding-bottom: 3px;
}
.menu-name { vertical-align: middle; }
.user_nav_bar { margin-left: 2.2rem; }
</style>



// WEBPACK FOOTER //
// src/components/shared/enterpriseadmin_sidebar_menu.vue